
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2qzBQ", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $44766eafbe4aebec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $44766eafbe4aebec$export$5c07a4287a46fa1f;

});

parcelRegister("jnPv4", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $5G9KX = parcelRequire("5G9KX");


var $7MobB = parcelRequire("7MobB");


var $6jKOp = parcelRequire("6jKOp");


var $3WVPu = parcelRequire("3WVPu");


var $5b4k9 = parcelRequire("5b4k9");


var $YBuvR = parcelRequire("YBuvR");

const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5b4k9.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $5G9KX.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $5G9KX.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $dh538.fg)('rovo_fps_use_rovo_config') || (0, $7MobB.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $3WVPu.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $YBuvR.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $YBuvR.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $5G9KX.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $6jKOp.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $582af5ffd704fa53$export$e89e805418f4d2c;

});

parcelRegister("7MobB", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $68435d39e6bf05f4$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $dh538.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $c6GJD.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $68435d39e6bf05f4$export$aa9f97d4dfccb6ff;

});

parcelRegister("6jKOp", function(module, exports) {
const $cb37190253d46910$var$NOT_AVAILABLE = 'not_available';
const $cb37190253d46910$export$fca3401e33379daf = (result)=>{
    if (result && typeof result === 'object' && 'extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            traceId: gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $cb37190253d46910$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $cb37190253d46910$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $cb37190253d46910$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $cb37190253d46910$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $cb37190253d46910$export$4acb28c262cd52bd;

});

parcelRegister("3WVPu", function(module, exports) {
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};
module.exports["getInstance"] = $fc16ad90038db0a8$export$8bedcca5bbd73999;

});

parcelRegister("3Tbc2", function(module, exports) {

var $fQifp = parcelRequire("fQifp");

const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000; // default timeout
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new (0, $fQifp.DegradeError)('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $3c05ea8f13f2fd4c$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9;

});

parcelRegister("fQifp", function(module, exports) {
class $821f2e34e1284477$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $821f2e34e1284477$export$85bf8e4fb143676a;

});

parcelRegister("johDC", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");


var $b48Gx = parcelRequire("b48Gx");



var $et7iT = parcelRequire("et7iT");


var $2IDcZ = parcelRequire("2IDcZ");

const $f5004564c119f753$export$3aaf902e00a8e4ba = (0, $hw4j5.inMemoryCache)();
const $f5004564c119f753$export$69a3209f1a06c04d = $f5004564c119f753$export$3aaf902e00a8e4ba;
const $f5004564c119f753$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
   * Results once fetched will be used for upto 15 minutes from an in memory cache.
   * 1. Generate key based on query, entities, filters
   * 2. Serve from cache if present without resetting the expiration, evict if results are expired
   * 3. If not present or expired then invoke the api
   * 4. If API is invoked then store response in the cache with expiration and return back the response
   */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        mercuryFilters: variables.mercuryFilters,
        compassFilters: variables.compassFilters,
        assetsFilters: variables.assetsFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $f5004564c119f753$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || !data.search || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $f5004564c119f753$var$searchQuery = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, useCache: useCache, operationName: operationName, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks })=>{
    // Default experience is search-page
    variables.experience = variables.experience || 'search-page';
    // Default skip3pEntityHydration is false
    variables.skip3pEntityHydration = variables.skip3pEntityHydration || variables.skipFieldsFor3pInQuickFind || false;
    // Disable GitHub hydration when skip3pEntityHydration is false to avoid duplication
    variables.includeGithubEntityHydration = !variables.skip3pEntityHydration ? false : variables.includeGithubEntityHydration || false;
    variables.includeSpaceSubtype = variables.includeSpaceSubtype || false;
    variables.skipFieldsFor3pInQuickFind = variables.skipFieldsFor3pInQuickFind || false;
    // Since the default experience is search-page, default experience is to include social signals
    variables.includeSocialSignals = variables.includeSocialSignals === undefined ? true : variables.includeSocialSignals;
    variables.includeJiraIssueType = variables.includeJiraIssueType || false;
    variables.includeJiraBoardContainer = variables.includeJiraBoardContainer || false; // Used to include the container field
    // Option to hydrate the confluenceEntity field
    variables.includeConfluenceEntity = typeof variables.includeConfluenceEntity === 'boolean' ? variables.includeConfluenceEntity : true;
    variables.includeAutocompleteSuggestions = variables.includeAutocompleteSuggestions || false;
    const graphQuery = (0, $2IDcZ.queryGenerator)(operationName, serveUserShardUI);
    if (useCache) return $f5004564c119f753$export$3aaf902e00a8e4ba.inMemoryDecorator($f5004564c119f753$export$a4f9b7f788f9e71f(variables, originalQuery), (0, $b48Gx.withNetworkCallback)(()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks), $f5004564c119f753$var$expireWhen);
    else return (0, $b48Gx.withNetworkCallback)(()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks)();
};
const $f5004564c119f753$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers })=>{
    return $f5004564c119f753$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: true,
        operationName: (0, $2IDcZ.SEARCH_PAGE_OPERATION_NAME),
        serveUserShardUI: serveUserShardUI,
        headers: headers
    });
};
const $f5004564c119f753$export$b62744f7ecc07873 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks })=>{
    return $f5004564c119f753$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: false,
        // Bypassing cache to match previous Quick Find behavior
        operationName: (0, $2IDcZ.SEARCH_DIALOG_OPERATION_NAME),
        serveUserShardUI: serveUserShardUI,
        headers: headers,
        networkCallbacks: networkCallbacks
    });
};
const $f5004564c119f753$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.resultsCountQueryGenerator)();
    return $f5004564c119f753$export$3aaf902e00a8e4ba.inMemoryDecorator('count' + $f5004564c119f753$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $2IDcZ.resultsCountOperationName),
            headers: headers
        }));
};
const $f5004564c119f753$export$c9f4828c7e4e077e = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $et7iT.dcSpaceFilterOptionsQueryGenerator)((0, $2IDcZ.jiraDcProjectFilterOptionsOperationName));
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.jiraDcProjectFilterOptionsOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$e261ee95abda868c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.spaceARIEntitiesQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.spaceARIEntitiesOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$d18b1cb9e3a2ff17 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.confluenceDcContentFilterOptionsQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcContentFilterOptionsOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$900adb6f362c0bd3 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.documentARIEntitiesQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.documentARIEntitiesOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$b2301b91ba090677 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.confluenceDcPagesQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcPagesOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$a4620a3105d92aba = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $et7iT.dcSpaceFilterOptionsQueryGenerator)((0, $2IDcZ.confluenceDcSpaceFilterOptionsOperationName));
    return (0, $4qT1X.fetchAgg)({
        variables: {
            ...variables,
            integration: 'ari:cloud:platform::integration/confluence-dc'
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcSpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$2e5009be45de0b79 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.thirdPartySpaceFilterOptionsQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.thirdPartySpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$54fa597426a1b0bc = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.thirdPartyRepositoryFilterOptionsQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.thirdPartyRepositoryFilterOptionsOperationName),
        headers: headers
    });
};
const $f5004564c119f753$export$3a1184d0405594d4 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $2IDcZ.searchLinkedSiteQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.searchLinkedSitesOperationName),
        headers: headers
    });
};
module.exports["searchPageQueryCache"] = $f5004564c119f753$export$3aaf902e00a8e4ba;
module.exports["searchDialogQuery"] = $f5004564c119f753$export$b62744f7ecc07873;
module.exports["jiraDcProjectFilterOptionsQuery"] = $f5004564c119f753$export$c9f4828c7e4e077e;
module.exports["spaceARIEntitiesQuery"] = $f5004564c119f753$export$e261ee95abda868c;
module.exports["confluenceDcContentFilterOptionsQuery"] = $f5004564c119f753$export$d18b1cb9e3a2ff17;
module.exports["documentARIEntitiesQuery"] = $f5004564c119f753$export$900adb6f362c0bd3;
module.exports["confluenceDcPagesQuery"] = $f5004564c119f753$export$b2301b91ba090677;
module.exports["confluenceDcSpaceFilterOptionsQuery"] = $f5004564c119f753$export$a4620a3105d92aba;
module.exports["thirdPartySpaceFilterOptionsQuery"] = $f5004564c119f753$export$2e5009be45de0b79;
module.exports["thirdPartyRepositoryFilterOptionsQuery"] = $f5004564c119f753$export$54fa597426a1b0bc;
module.exports["searchLinkedSitesQuery"] = $f5004564c119f753$export$3a1184d0405594d4;

});

parcelRegister("4qT1X", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

const $d58482f4fb1880c9$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d58482f4fb1880c9$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d58482f4fb1880c9$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAgg"] = $d58482f4fb1880c9$export$f49dad89491f6bf2;

});

parcelRegister("hw4j5", function(module, exports) {

var $3WVPu = parcelRequire("3WVPu");

const $553ad7df36a4ab29$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $3WVPu.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $553ad7df36a4ab29$export$26b8d9fa10eeb703;

});

parcelRegister("b48Gx", function(module, exports) {

var $6jKOp = parcelRequire("6jKOp");

const $4b0fac9d3d6e1423$export$6f045830bd67248c = (fn, callbacks)=>{
    if (!callbacks) return fn;
    return async ()=>{
        callbacks.onStart();
        try {
            const result = await fn();
            const traceInfo = (0, $6jKOp.extractTraceInfoFromResponse)(result);
            callbacks.onSuccess(traceInfo);
            return result;
        } catch (error) {
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message || 'An unknown error occurred';
            callbacks.onError(errorName, errorMessage);
            throw error;
        }
    };
};
module.exports["withNetworkCallback"] = $4b0fac9d3d6e1423$export$6f045830bd67248c;

});

parcelRegister("et7iT", function(module, exports) {
const $76f3a952da7615f2$export$5fcc1d1055e1b5a6 = (operationName)=>{
    const graphQuery = `
		query ${operationName} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$containerTypes: [String!]
			) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					containerTypes : $containerTypes,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
					subtypes:[]
					}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
					...on SearchResultGraphDocument {
						entity {
							...on ExternalSpace {
									id
									key
									displayName
									icon {
										height
										isDefault
										url
										width
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
module.exports["dcSpaceFilterOptionsQueryGenerator"] = $76f3a952da7615f2$export$5fcc1d1055e1b5a6;

});

parcelRegister("2IDcZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $74Da5 = parcelRequire("74Da5");


const $785ae870bae9105a$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $785ae870bae9105a$export$ba7243e49f8daaa4 = 'SearchPageQuery';
const $785ae870bae9105a$export$87e857ecc7765700 = 'SearchDialogQuery';
const $785ae870bae9105a$var$includeUserSignalsParam = (serveUserShardUI = false)=>{
    if (serveUserShardUI) return '\n		$includeUserSignals: Boolean!';
    else return '';
};
const $785ae870bae9105a$export$bcad4d0714f0772f = (operationName, serveUserShardUI = false)=>{
    const partials = (0, $74Da5.getSupportedPartials)(serveUserShardUI);
    const graphQuery = `
	query ${operationName}(
		$query: String!
		$cloudIdARI: [String!]!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$sessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $dh538.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $dh538.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$enableHighlighting: Boolean
		$skip3pEntityHydration: Boolean!
		$includeGithubEntityHydration: Boolean! = false
		$includeJiraIssueType: Boolean!
		$includeJiraBoardContainer: Boolean!
		$includeSocialSignals: Boolean!${$785ae870bae9105a$var$includeUserSignalsParam(serveUserShardUI)}
		$fanoutExperimentCohort: String
		$includeSpaceSubtype: Boolean!
		$includeConfluenceEntity: Boolean!
		$skipFieldsFor3pInQuickFind: Boolean!
		$includeAutocompleteSuggestions: Boolean = false
	) {
		search {
			results: search(
				experience: $experience
				enableHighlighting: $enableHighlighting
				fanoutExperimentCohort: $fanoutExperimentCohort
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: $cloudIdARI
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					${(0, $dh538.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
					mercuryFilters: $mercuryFilters
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $dh538.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
				}
				analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sessionId: $sessionId
					sourceProduct: $sourceProduct
				}
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
			) {
				edges {
					node {
						${$785ae870bae9105a$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					suggestedQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
				autocompleteSuggestions @include(if: $includeAutocompleteSuggestions)
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $785ae870bae9105a$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$785ae870bae9105a$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $dh538.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $dh538.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					${(0, $dh538.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $dh538.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$fa19606e35da8d6d = 'jiraDcProjectFilterOptionsQuery';
const $785ae870bae9105a$export$56917484085c839f = 'confluenceDcSpaceFilterOptionsQuery';
const $785ae870bae9105a$export$7fed2443afa81b26 = 'thirdPartySpaceFilterOptionsQuery';
const $785ae870bae9105a$export$5fce5a96ced87ae4 = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$7fed2443afa81b26} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalSpace {
									id
									displayName
									icon {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$8535d2c38a35eb6f = 'teamsWorkspaceFilterOptionsQuery';
const $785ae870bae9105a$export$baa4ec00dd3889d8 = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$8535d2c38a35eb6f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalConversation {
									workspace
									id
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$c768638eb8676119 = 'thirdPartyRepositoryFilterOptionsQuery';
const $785ae870bae9105a$export$3057eb5718aa2977 = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$c768638eb8676119} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalRepository {
									id
									name
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$4cc1a613b784cede = 'spaceIdFilterOptionsQuery';
const $785ae870bae9105a$export$402074cb9d99809d = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$4cc1a613b784cede} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				space {
					id
					displayName
					icon {
						url
					}
				}
			}
		}`;
    return graphQuery;
};
const $785ae870bae9105a$export$fd96e79bbd846735 = 'documentIdFilterOptionsQuery';
const $785ae870bae9105a$export$36d0a57a2adc8939 = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$fd96e79bbd846735} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				document {
					id
					displayName
					container @optIn(to: "ExternalDataDepotQueryV2") {
                        ... on ExternalSpace {
                            id
                        }
                    }
				}
			}
		}`;
    return graphQuery;
};
const $785ae870bae9105a$export$11124ad4475d739f = 'confluenceDcContentFilterOptionsQuery';
const $785ae870bae9105a$export$80a2987504e5746a = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$11124ad4475d739f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				locations: [$cloudIdARI],
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId:"ari:cloud:platform::integration/confluence-dc",
							subtypes:[]
						}
					]
				}
			}
			analytics: {searchSessionId: "graphql"}
			experience: "search-page"
			) {
				edges {
					node {
					id
					title
					description
					... on SearchResultGraphDocument {
							entity {
								...on ExternalDocument {
									type {
										category
									}
									parentId
									container @optIn(to: "ExternalDataDepotQueryV2") {
										...on ExternalSpace {
											id
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$b12a4e91aeaa7036 = 'confluenceDcPagesQuery';
const $785ae870bae9105a$export$feafc9cb648273dc = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$b12a4e91aeaa7036} (
			$ancestorIds: [ID!]!
		) {
			external_entities(ids: $ancestorIds) @optIn(to: "ExternalDataDepotQueryV2") {
				document {
					id
					displayName
				}
			}
		}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$b6579c18b8ca60cd = 'CollabContextWorkspaceIsConnectedToWorkspaceQuery';
const $785ae870bae9105a$export$4d33288c2a5c7de0 = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$b6579c18b8ca60cd}($id: ID!) {
			collabContext_workspaceIsConnectedToWorkspace(id: $id) {
				edges {
					node {
						id
					}
					cursor
				}
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
			}
		}
	`;
    return graphQuery;
};
module.exports["SEARCH_PAGE_OPERATION_NAME"] = $785ae870bae9105a$export$ba7243e49f8daaa4;
module.exports["SEARCH_DIALOG_OPERATION_NAME"] = $785ae870bae9105a$export$87e857ecc7765700;
module.exports["queryGenerator"] = $785ae870bae9105a$export$bcad4d0714f0772f;
module.exports["resultsCountOperationName"] = $785ae870bae9105a$export$59ff8b98cf7da770;
module.exports["resultsCountQueryGenerator"] = $785ae870bae9105a$export$35addfdbe1c7b563;
module.exports["jiraDcProjectFilterOptionsOperationName"] = $785ae870bae9105a$export$fa19606e35da8d6d;
module.exports["confluenceDcSpaceFilterOptionsOperationName"] = $785ae870bae9105a$export$56917484085c839f;
module.exports["thirdPartySpaceFilterOptionsOperationName"] = $785ae870bae9105a$export$7fed2443afa81b26;
module.exports["thirdPartySpaceFilterOptionsQueryGenerator"] = $785ae870bae9105a$export$5fce5a96ced87ae4;
module.exports["teamsWorkspaceFilterOptionsOperationName"] = $785ae870bae9105a$export$8535d2c38a35eb6f;
module.exports["teamsWorkspaceFilterOptionsQueryGenerator"] = $785ae870bae9105a$export$baa4ec00dd3889d8;
module.exports["thirdPartyRepositoryFilterOptionsOperationName"] = $785ae870bae9105a$export$c768638eb8676119;
module.exports["thirdPartyRepositoryFilterOptionsQueryGenerator"] = $785ae870bae9105a$export$3057eb5718aa2977;
module.exports["spaceARIEntitiesOperationName"] = $785ae870bae9105a$export$4cc1a613b784cede;
module.exports["spaceARIEntitiesQueryGenerator"] = $785ae870bae9105a$export$402074cb9d99809d;
module.exports["documentARIEntitiesOperationName"] = $785ae870bae9105a$export$fd96e79bbd846735;
module.exports["documentARIEntitiesQueryGenerator"] = $785ae870bae9105a$export$36d0a57a2adc8939;
module.exports["confluenceDcContentFilterOptionsOperationName"] = $785ae870bae9105a$export$11124ad4475d739f;
module.exports["confluenceDcContentFilterOptionsQueryGenerator"] = $785ae870bae9105a$export$80a2987504e5746a;
module.exports["confluenceDcPagesOperationName"] = $785ae870bae9105a$export$b12a4e91aeaa7036;
module.exports["confluenceDcPagesQueryGenerator"] = $785ae870bae9105a$export$feafc9cb648273dc;
module.exports["searchLinkedSitesOperationName"] = $785ae870bae9105a$export$b6579c18b8ca60cd;
module.exports["searchLinkedSiteQueryGenerator"] = $785ae870bae9105a$export$4d33288c2a5c7de0;

});

parcelRegister("74Da5", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $l3paI = parcelRequire("l3paI");


var $7jIfa = parcelRequire("7jIfa");


var $b8N8h = parcelRequire("b8N8h");


var $4TTdD = parcelRequire("4TTdD");


var $8LSUr = parcelRequire("8LSUr");


var $HOiSI = parcelRequire("HOiSI");


var $fhFN4 = parcelRequire("fhFN4");


var $fLF8J = parcelRequire("fLF8J");


var $7ZetK = parcelRequire("7ZetK");


var $aXWlG = parcelRequire("aXWlG");

const $3e4e4f06bb78dccc$export$9f64d624a5905b0b = (serveUserShardUI = false)=>{
    return `
		${(0, $4TTdD.getConfluencePartials)(serveUserShardUI)}
		${(0, $8LSUr.getJiraPartials)()}
		${(0, $aXWlG.getTrelloPartials)()}
		${(0, $7jIfa.getAtlasPartials)()}
		${(0, $b8N8h.getCompassPartials)()}
		${(0, $HOiSI.getMercuryPartials)()}
		${(0, $7ZetK.getGraphPartials)()}
		${(0, $fLF8J.getFederatedPartials)()}
		${(0, $dh538.fg)('assets_rovo_search_all') ? (0, $l3paI.getAssetsPartials)() : ''}
		${(0, $dh538.fg)('talent_global_search') ? (0, $fhFN4.getTalentPartials)() : ''}
	`;
};
module.exports["getSupportedPartials"] = $3e4e4f06bb78dccc$export$9f64d624a5905b0b;

});

parcelRegister("l3paI", function(module, exports) {
const $95de5e3c2d86e116$export$6cb3c23f8cc6b5c8 = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		links {
			web
		}
	}
}
`;
const $95de5e3c2d86e116$export$6d6066e039c821f2 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectSchema';
};
const $95de5e3c2d86e116$export$f160c48c1d037f87 = ()=>{
    return `
		${$95de5e3c2d86e116$export$6cb3c23f8cc6b5c8}
	`;
};
const $95de5e3c2d86e116$export$6ff43818aa330e52 = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		icon {
			url48
		}
		links {
			web
		}
	}
}
`;
const $95de5e3c2d86e116$export$477919e939be033d = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectType';
};
const $95de5e3c2d86e116$export$f11c57703f5bd591 = ()=>{
    return `
		${$95de5e3c2d86e116$export$6ff43818aa330e52}
	`;
};
const $95de5e3c2d86e116$export$e3c6dbbf952d90ed = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name

	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
`;
const $95de5e3c2d86e116$export$6cfcb9e6160b8854 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObject';
};
const $95de5e3c2d86e116$export$48a3d1cc8f03ffb9 = ()=>{
    return `
		${$95de5e3c2d86e116$export$e3c6dbbf952d90ed}
	`;
};
const $95de5e3c2d86e116$export$b66206b66084d78d = (partial)=>{
    return $95de5e3c2d86e116$export$6d6066e039c821f2(partial) || $95de5e3c2d86e116$export$477919e939be033d(partial) || $95de5e3c2d86e116$export$6cfcb9e6160b8854(partial);
};
const $95de5e3c2d86e116$export$d49a85cc2b961760 = ()=>{
    return `
		${$95de5e3c2d86e116$export$f160c48c1d037f87()}
		${$95de5e3c2d86e116$export$f11c57703f5bd591()}
		${$95de5e3c2d86e116$export$48a3d1cc8f03ffb9()}
	`;
};
module.exports["isSearchResultAssetsObjectSchema"] = $95de5e3c2d86e116$export$6d6066e039c821f2;
module.exports["isSearchResultAssetsObjectType"] = $95de5e3c2d86e116$export$477919e939be033d;
module.exports["isSearchResultAssetsObject"] = $95de5e3c2d86e116$export$6cfcb9e6160b8854;
module.exports["isSearchAssetsPartial"] = $95de5e3c2d86e116$export$b66206b66084d78d;
module.exports["getAssetsPartials"] = $95de5e3c2d86e116$export$d49a85cc2b961760;

});

parcelRegister("7jIfa", function(module, exports) {
const $c12c29bc71ee9715$var$SearchDefaultResultAtlas = ``;
const $c12c29bc71ee9715$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
const $c12c29bc71ee9715$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $c12c29bc71ee9715$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $c12c29bc71ee9715$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $c12c29bc71ee9715$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $c12c29bc71ee9715$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $c12c29bc71ee9715$export$750af6f011d7ee10 = (partial)=>{
    return $c12c29bc71ee9715$export$1d556a3125797ca6(partial) || $c12c29bc71ee9715$export$1724df33341798e0(partial) || $c12c29bc71ee9715$export$bff995b1cea89df3(partial) || $c12c29bc71ee9715$export$aa63de26c950cf0f(partial);
};
const $c12c29bc71ee9715$export$272c689528faac47 = ()=>{
    return `
		${$c12c29bc71ee9715$var$SearchResultAtlasGoal}
		${$c12c29bc71ee9715$var$SearchResultAtlasProject}
		${$c12c29bc71ee9715$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $c12c29bc71ee9715$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $c12c29bc71ee9715$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $c12c29bc71ee9715$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $c12c29bc71ee9715$export$272c689528faac47;

});

parcelRegister("b8N8h", function(module, exports) {
const $a1dfc2d141dab226$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $a1dfc2d141dab226$export$72cf2e1294c50ff4 = ()=>{
    return $a1dfc2d141dab226$var$SearchResultCompassComponent;
};
const $a1dfc2d141dab226$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $a1dfc2d141dab226$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $a1dfc2d141dab226$export$b8968ce5f9785283;

});

parcelRegister("4TTdD", function(module, exports) {
const $ce6442228f6f128a$var$SearchConfluencePageBlogAttachment = (serveUserShardUI)=>`
... on SearchConfluencePageBlogAttachment {
	lastModified
	${serveUserShardUI ? `
	latestUserAction @include(if: $includeUserSignals)
	latestUserActionTs @include(if: $includeUserSignals)
	` : ''}
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity @include(if: $includeConfluenceEntity) {
		... on ConfluencePage {
			subtype
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
	}
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $ce6442228f6f128a$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
const $ce6442228f6f128a$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $ce6442228f6f128a$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $ce6442228f6f128a$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $ce6442228f6f128a$export$c89c057fd480d10c(partial) || $ce6442228f6f128a$export$4619f000f23ee8d1(partial);
};
const $ce6442228f6f128a$export$d1ddb94b35ac2d77 = (serveUserShardUI = false)=>{
    return `
		${$ce6442228f6f128a$var$SearchConfluencePageBlogAttachment(serveUserShardUI)}
		${$ce6442228f6f128a$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $ce6442228f6f128a$export$c89c057fd480d10c;
module.exports["isSearchConfluenceSpace"] = $ce6442228f6f128a$export$4619f000f23ee8d1;
module.exports["isSearchConfluencePartial"] = $ce6442228f6f128a$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $ce6442228f6f128a$export$d1ddb94b35ac2d77;

});

parcelRegister("8LSUr", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $36aa3ff758e375d9$var$getSearchResultJiraProject = ()=>`
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project {
    webUrl
  }
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}`;
const $36aa3ff758e375d9$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $36aa3ff758e375d9$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  issueTypeId
  status {
    id
    name
  }
  issue {
    webUrl
		key
		assigneeField {
			user {
				name
				picture
			}
		}
    fieldsById(ids: ["project"]) {
      edges {
        node {
          __typename
          name
          ... on JiraProjectField {
            project {
              id
              name
			  projectType
            }
          }
        }
      }
    }
			issueTypeAvatarUrl
		issueTypeField @include(if: $includeJiraIssueType) {
			id
			issueType {
				id
				name
			}
		}
  }
  socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
  __typename
}
`;
const $36aa3ff758e375d9$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $36aa3ff758e375d9$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $36aa3ff758e375d9$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $36aa3ff758e375d9$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $36aa3ff758e375d9$export$832b8ae8473ed171 = ``;
const $36aa3ff758e375d9$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $36aa3ff758e375d9$export$7860041bfeffea77 = ``;
const $36aa3ff758e375d9$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $36aa3ff758e375d9$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container @include(if: $includeJiraBoardContainer) {
		__typename
		... on SearchResultJiraBoardProjectContainer {
			__typename
			projectName
		}
		... on SearchResultJiraBoardUserContainer {
			__typename
			userName
		}
	}
	board {
		boardFrontendUrl
		iconUrl
	}
  product
}
`;
const $36aa3ff758e375d9$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $36aa3ff758e375d9$export$56752b3c89cc8a9e = (partial)=>{
    return partial.__typename === 'SearchResultJiraPlan';
};
const $36aa3ff758e375d9$export$5a36738ca5faa27f = (partial)=>{
    return $36aa3ff758e375d9$export$aab3eed7c97209f8(partial) || $36aa3ff758e375d9$export$e221e36ba6e9f139(partial) || $36aa3ff758e375d9$export$e0968d23c481cf04(partial) || $36aa3ff758e375d9$export$3e9a71746a0d5ef1(partial) || $36aa3ff758e375d9$export$98e434e98950249c(partial) || $36aa3ff758e375d9$export$56752b3c89cc8a9e(partial);
};
const $36aa3ff758e375d9$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$36aa3ff758e375d9$var$getSearchResultJiraProject()}
		${$36aa3ff758e375d9$export$1f4b5d2e43f14510}
		${$36aa3ff758e375d9$export$832b8ae8473ed171}
		${$36aa3ff758e375d9$export$7860041bfeffea77}
		${$36aa3ff758e375d9$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $36aa3ff758e375d9$export$aab3eed7c97209f8;
module.exports["isSearchResultJiraIssue"] = $36aa3ff758e375d9$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $36aa3ff758e375d9$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $36aa3ff758e375d9$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $36aa3ff758e375d9$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $36aa3ff758e375d9$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $36aa3ff758e375d9$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $36aa3ff758e375d9$export$d1f9da0e5c74ebcb;

});

parcelRegister("HOiSI", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $99673f5e61e3ceb4$var$SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		uuid
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultMercuryOrganization = `
... on SearchResultMercuryOrganization {
	lastModifiedDate
	organization @optIn(to: "Mercury") {
		id
		name
		organizationType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultMercuryOrganizationStatusUpdate = `
... on SearchResultMercuryOrganizationStatusUpdate {
	lastModifiedDate
	organization @optIn(to: "Mercury") {
		name
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultSpfAskPartial = `
... on SearchResultSpfAsk {
	lastModifiedDate
	ask @optIn(to: "Spf") {
		id
		name
		status
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultMercuryRiskPartial = `
... on SearchResultMercuryRisk {
	lastModifiedDate
	risk @optIn(to: "Mercury") {
		id
		name
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $99673f5e61e3ceb4$export$8b0a4c9077b7d09b = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};
const $99673f5e61e3ceb4$export$c43349f9a39b01bd = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};
const $99673f5e61e3ceb4$export$d3264e7771e87974 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganization';
};
const $99673f5e61e3ceb4$export$aa29d4d3bbbb9e32 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganizationStatusUpdate';
};
const $99673f5e61e3ceb4$export$68b5e30200895184 = (partial)=>{
    return partial?.id?.includes('passionfruit') && partial.__typename === 'SearchResultSpfAsk';
};
const $99673f5e61e3ceb4$export$180dc91590735353 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryRisk';
};
const $99673f5e61e3ceb4$export$bbfb216d33463101 = (partial)=>{
    return $99673f5e61e3ceb4$export$8b0a4c9077b7d09b(partial) || $99673f5e61e3ceb4$export$c43349f9a39b01bd(partial) || $99673f5e61e3ceb4$export$68b5e30200895184(partial) || $99673f5e61e3ceb4$export$180dc91590735353(partial) || $99673f5e61e3ceb4$export$d3264e7771e87974(partial) || $99673f5e61e3ceb4$export$aa29d4d3bbbb9e32(partial);
};
const $99673f5e61e3ceb4$export$fabaf03f9e1d6e25 = ()=>{
    return `
		${$99673f5e61e3ceb4$var$SearchResultMercuryFocusArea}
		${$99673f5e61e3ceb4$var$SearchResultMercuryFocusAreaStatusUpdate}
		${(0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled') ? $99673f5e61e3ceb4$var$SearchResultSpfAskPartial : ''}
		${(0, $dh538.fg)('platform_mercury_risk_search_ui_enabled') ? $99673f5e61e3ceb4$var$SearchResultMercuryRiskPartial : ''}
		${(0, $dh538.fg)('platform_organization_search_onboarding_enabled') ? $99673f5e61e3ceb4$var$SearchResultMercuryOrganization : ''}
		${(0, $dh538.fg)('platform_organization_search_onboarding_enabled') ? $99673f5e61e3ceb4$var$SearchResultMercuryOrganizationStatusUpdate : ''}
	`;
};
module.exports["isSearchResultMercuryFocusAreaPartial"] = $99673f5e61e3ceb4$export$8b0a4c9077b7d09b;
module.exports["isSearchResultMercuryFocusAreaStatusUpdatePartial"] = $99673f5e61e3ceb4$export$c43349f9a39b01bd;
module.exports["isSearchResultMercuryOrganizationPartial"] = $99673f5e61e3ceb4$export$d3264e7771e87974;
module.exports["isSearchResultMercuryOrganizationStatusUpdatePartial"] = $99673f5e61e3ceb4$export$aa29d4d3bbbb9e32;
module.exports["isSearchResultSpfAskPartial"] = $99673f5e61e3ceb4$export$68b5e30200895184;
module.exports["isSearchMercuryPartial"] = $99673f5e61e3ceb4$export$bbfb216d33463101;
module.exports["getMercuryPartials"] = $99673f5e61e3ceb4$export$fabaf03f9e1d6e25;

});

parcelRegister("fhFN4", function(module, exports) {
const $bd8c57eea7954722$var$SearchResultTalentPosition = `
... on SearchResultTalentPosition {
	__typename
	lastModifiedDate
	position {
		__typename
		worker {
			preferredName
			user {
				picture
			}
		}
		fieldValues(
			fieldIdIsIn: [
				"positionId",
				"positionStatus",
				"positionJobTitle",
				"positionPositionTitle",
				"positionKey",
				"positionExternalPositionKey",
				"positionWorker"
			]
		) {
			fieldId
			fieldValue {
				__typename
				... on RadarStringFieldValue {
					__typename
					stringValue: value
				}
			}
		}
	}
}
`;
const $bd8c57eea7954722$export$81d91ad826853e38 = (partial)=>{
    return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};
const $bd8c57eea7954722$export$4f87e53676ad17f4 = (partial)=>{
    return $bd8c57eea7954722$export$81d91ad826853e38(partial);
};
const $bd8c57eea7954722$export$f39ac0d11d2a4da = ()=>{
    return `
		${$bd8c57eea7954722$var$SearchResultTalentPosition}
	`;
};
module.exports["isSearchTalentPartial"] = $bd8c57eea7954722$export$4f87e53676ad17f4;
module.exports["getTalentPartials"] = $bd8c57eea7954722$export$f39ac0d11d2a4da;

});

parcelRegister("fLF8J", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");


var $eUkvc = parcelRequire("eUkvc");

const $fc6808f27e8b1a8d$var$SearchResultFederatedPartial = `
... on SearchResultFederated @skip(if: $skipFieldsFor3pInQuickFind) {
	lastModifiedDate
	entity {
		${(0, $eUkvc.FederatedEmailPartial)}
	}
}
`;
var $fc6808f27e8b1a8d$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($fc6808f27e8b1a8d$var$ResourceType || {});
const $fc6808f27e8b1a8d$export$68ef445facedc0d5 = ()=>{
    return $fc6808f27e8b1a8d$var$SearchResultFederatedPartial;
};
const $fc6808f27e8b1a8d$export$4fafa9bf7ad5438a = (partial)=>partial.__typename === 'SearchResultFederated';
const $fc6808f27e8b1a8d$export$c0c573cc3dff9ad6 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "email";
};
module.exports["getFederatedPartials"] = $fc6808f27e8b1a8d$export$68ef445facedc0d5;

});

parcelRegister("eUkvc", function(module, exports) {
const $e45ad8a5309338bf$export$7c3d5c670817fb18 = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;
module.exports["FederatedEmailPartial"] = $e45ad8a5309338bf$export$7c3d5c670817fb18;

});

parcelRegister("7ZetK", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $k4HRJ = parcelRequire("k4HRJ");


var $gJtY1 = parcelRequire("gJtY1");


var $lg5f1 = parcelRequire("lg5f1");


var $8nePj = parcelRequire("8nePj");


var $cLzNH = parcelRequire("cLzNH");


var $hz68i = parcelRequire("hz68i");


var $kAvaS = parcelRequire("kAvaS");


var $9SGbr = parcelRequire("9SGbr");


var $jj5HY = parcelRequire("jj5HY");


var $3pr5k = parcelRequire("3pr5k");


var $Qrt3A = parcelRequire("Qrt3A");


var $dehBN = parcelRequire("dehBN");


var $9mUth = parcelRequire("9mUth");


var $aJW2w = parcelRequire("aJW2w");


var $4tpwN = parcelRequire("4tpwN");


var $iCTu1 = parcelRequire("iCTu1");


var $kRTZx = parcelRequire("kRTZx");


var $4Kdn3 = parcelRequire("4Kdn3");


var $kt77u = parcelRequire("kt77u");


var $7lYRh = parcelRequire("7lYRh");


var $kZuSh = parcelRequire("kZuSh");


var $bwf3l = parcelRequire("bwf3l");

const $2bedd5b6e3cb42cc$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $2bedd5b6e3cb42cc$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	excerpt @skip(if: $skipFieldsFor3pInQuickFind)
	permissionLevel @skip(if: $skipFieldsFor3pInQuickFind)
	initialContributors @skip(if: $skipFieldsFor3pInQuickFind) {
		name
		id
		externalId
	}
	subtype
	integrationId
	providerId
	connectorType
	lastModifiedDate
	linkedEntities @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity @skip(if: $skip3pEntityHydration) {
			${(0, $iCTu1.ExternalMessagePartial)}
		}
		initialContributors {
			name
			id
			externalId
		}
		containerName @optIn(to: "SearchPerformanceImprovementChanges")
		allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
	}
	entity @skip(if: $skip3pEntityHydration) {
		${(0, $gJtY1.ExternalBranchPartial)}
		${(0, $lg5f1.ExternalCalendarEventPartial)}
		${(0, $8nePj.ExternalCampaignPartial)}
		${(0, $cLzNH.ExternalCasePartial)}
		${(0, $9mUth.ExternalDealPartial)}
		${(0, $3pr5k.ExternalCustomerOrgPartial)}
		${(0, $9SGbr.ExternalCommitPartial)}
		${(0, $jj5HY.ExternalConversationPartial)}
		${(0, $aJW2w.ExternalDesignPartial)}
		${(0, $Qrt3A.ExternalDashboardPartial)}
		${(0, $dehBN.ExternalDataTablePartial)}
		${(0, $4tpwN.ExternalDocumentPartial)}
		${(0, $iCTu1.ExternalMessagePartial)}
		${(0, $kRTZx.ExternalProjectPartial)}
		${(0, $4Kdn3.ExternalPullRequestPartial)}
		${(0, $7lYRh.ExternalRepositoryPartial)}
		${(0, $kZuSh.ExternalVideoPartial)}
		${(0, $bwf3l.ExternalWorkItemPartial)}
		${(0, $kAvaS.ExternalCommentPartial)}
		${(0, $kt77u.ExternalRemoteLinkPartial)}
	}
	entity @include(if: $includeGithubEntityHydration) {
		${(0, $4Kdn3.ExternalPullRequestPartial)}
		${(0, $7lYRh.ExternalRepositoryPartial)}
		${(0, $bwf3l.ExternalWorkItemPartial)}
	}
	containerName @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind)
	allContributors @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		accountId
		externalId
		name
		nickname
		email
		picture
		extendedProfile {
			jobTitle
			department
			organization
		}
	}
	linkedResults @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
var $2bedd5b6e3cb42cc$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($2bedd5b6e3cb42cc$var$AccountStatus || {});
var $2bedd5b6e3cb42cc$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($2bedd5b6e3cb42cc$var$ExternalDocumentCategory || {});
var $2bedd5b6e3cb42cc$var$ExternalEventType = /*#__PURE__*/ function(ExternalEventType) {
    ExternalEventType["APPOINTMENT"] = "appointment";
    ExternalEventType["BIRTHDAY"] = "birthday";
    ExternalEventType["DEFAULT"] = "default";
    ExternalEventType["EVENT"] = "event";
    ExternalEventType["FOCUS_TIME"] = "focus_time";
    ExternalEventType["OUT_OF_OFFICE"] = "out_of_office";
    ExternalEventType["REMINDER"] = "reminder";
    ExternalEventType["TASK"] = "task";
    ExternalEventType["WORKING_LOCATION"] = "working_location";
    return ExternalEventType;
}($2bedd5b6e3cb42cc$var$ExternalEventType || {});
var $2bedd5b6e3cb42cc$var$ExternalAttendeeRsvpStatus = /*#__PURE__*/ function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["ACCEPTED"] = "accepted";
    ExternalAttendeeRsvpStatus["DECLINED"] = "declined";
    ExternalAttendeeRsvpStatus["NOT_RESPONDED"] = "not_responded";
    ExternalAttendeeRsvpStatus["OTHER"] = "other";
    ExternalAttendeeRsvpStatus["TENATIVELY_ACCEPTED"] = "tenatively_accepted";
    return ExternalAttendeeRsvpStatus;
}($2bedd5b6e3cb42cc$var$ExternalAttendeeRsvpStatus || {});
var $2bedd5b6e3cb42cc$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "task";
    ExternalWorkItemType["DEFAULT_TASK"] = "default_task";
    ExternalWorkItemType["WORK_ITEM"] = "work_item";
    ExternalWorkItemType["EPIC"] = "epic";
    ExternalWorkItemType["BUG"] = "bug";
    ExternalWorkItemType["STORY"] = "story";
    ExternalWorkItemType["MILESTONE"] = "milestone";
    ExternalWorkItemType["SECTION"] = "section";
    ExternalWorkItemType["APPROVAL"] = "approval";
    ExternalWorkItemType["PROBLEM"] = "problem";
    ExternalWorkItemType["INCIDENT"] = "incident";
    ExternalWorkItemType["QUESTION"] = "question";
    ExternalWorkItemType["ISSUE"] = "issue";
    ExternalWorkItemType["TICKET"] = "ticket";
    ExternalWorkItemType["REQUESTED_ITEM"] = "requested_item";
    ExternalWorkItemType["CATALOG_ITEM"] = "catalog_item";
    ExternalWorkItemType["OTHER"] = "other";
    return ExternalWorkItemType;
}($2bedd5b6e3cb42cc$var$ExternalWorkItemType || {});
var $2bedd5b6e3cb42cc$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($2bedd5b6e3cb42cc$var$ExternalMembershipType || {});
var $2bedd5b6e3cb42cc$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($2bedd5b6e3cb42cc$var$ExternalConversationType || {});
var $2bedd5b6e3cb42cc$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["CAMPAIGN"] = "campaign";
    ResourceType["CASE"] = "case";
    ResourceType["DEAL"] = "deal";
    ResourceType["CUSTOMER_ORG"] = "customer-org";
    ResourceType["CUSTOMER_CONTACT"] = "customer-contact";
    ResourceType["COMMENT"] = "comment";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PROJECT"] = "project";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    ResourceType["SPACE"] = "space";
    ResourceType["REMOTE_LINK"] = "remote-link";
    ResourceType["DASHBOARD"] = "dashboard";
    ResourceType["DATA_TABLE"] = "data-table";
    return ResourceType;
}({});
const $2bedd5b6e3cb42cc$export$e169b729a14ad5f8 = ()=>{
    // One inline fragment per top-level 3P SearchResult subtype. Code results are a
    // distinct GraphQL type (SearchResultGraphCode); all other 3P documents share
    // SearchResultGraphDocument and discriminate via `entity { ... on ExternalX }`.
    // SearchResultGraphCode is gated to limit blast radius until the experiment ships.
    const partials = [
        $2bedd5b6e3cb42cc$var$SearchThirdPartyGraphDocumentPartial
    ];
    if ((0, $dh538.fg)('rovo_github_code_search')) partials.push((0, $hz68i.ExternalCodePartial));
    return partials.join('\n');
};
const $2bedd5b6e3cb42cc$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $2bedd5b6e3cb42cc$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $2bedd5b6e3cb42cc$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $2bedd5b6e3cb42cc$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $2bedd5b6e3cb42cc$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $2bedd5b6e3cb42cc$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $2bedd5b6e3cb42cc$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $2bedd5b6e3cb42cc$export$5bdc07901b0022c6 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "comment";
};
const $2bedd5b6e3cb42cc$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $2bedd5b6e3cb42cc$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $2bedd5b6e3cb42cc$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $2bedd5b6e3cb42cc$export$791f1b4852e2a184 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "project";
};
const $2bedd5b6e3cb42cc$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $2bedd5b6e3cb42cc$export$e23befac5f018c0b = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "deal";
};
const $2bedd5b6e3cb42cc$export$8d26baa8fb7886c4 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "case";
};
const $2bedd5b6e3cb42cc$export$4b4ac5f6534c6ce2 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "campaign";
};
const $2bedd5b6e3cb42cc$export$1aff0f2a91c0ea03 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "customer-org";
};
const $2bedd5b6e3cb42cc$export$40f90006d8fc8dee = (partial)=>$2bedd5b6e3cb42cc$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $2bedd5b6e3cb42cc$var$TEAMS_INTEGRATION_ARI;
const $2bedd5b6e3cb42cc$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
const $2bedd5b6e3cb42cc$export$b10c98faa2e0b99a = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "dashboard";
};
const $2bedd5b6e3cb42cc$export$a24b6b49e5e27b50 = (partial)=>partial.__typename === 'SearchResultGraphCode';
const $2bedd5b6e3cb42cc$export$c9efee8db4eaf865 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "data-table";
};
module.exports["ResourceType"] = $2bedd5b6e3cb42cc$export$c6f9da6f70cfc2eb;
module.exports["getGraphPartials"] = $2bedd5b6e3cb42cc$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $2bedd5b6e3cb42cc$export$7dd4baba91338caa;
module.exports["isPullRequestEntity"] = $2bedd5b6e3cb42cc$export$5ba84cc314040e0c;
module.exports["isDocumentEntity"] = $2bedd5b6e3cb42cc$export$32c06ee7e0e9b79e;
module.exports["isWorkItemEntity"] = $2bedd5b6e3cb42cc$export$162dad7a1238d377;
module.exports["isCodeResult"] = $2bedd5b6e3cb42cc$export$a24b6b49e5e27b50;

});

parcelRegister("gJtY1", function(module, exports) {
const $db19e1fa6f2ae0df$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $db19e1fa6f2ae0df$export$5b6173385ccfaeaa;

});

parcelRegister("lg5f1", function(module, exports) {
const $a3f6d52c4a595b9b$export$253480f0254db4f8 = `
... on ExternalCalendarEvent {
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	attendees {
		isOptional
		rsvpStatus
		user {
			thirdPartyUser {
				id
				email
				name
			}
			user {
				name
			}
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			externalId
			name
			picture
		}
		user {
			name
		}
	}
	eventEndTime
	eventStartTime
	eventType
	location {
		address
		coordinates
		name
		url
	}
	recurringEventId
	videoMeetingUrl
}
`;
module.exports["ExternalCalendarEventPartial"] = $a3f6d52c4a595b9b$export$253480f0254db4f8;

});

parcelRegister("8nePj", function(module, exports) {
const $bff6195e160eb6bb$export$e6966bd80a36700a = `
... on ExternalCampaign {
	status
	startDate
	endDate
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalCampaignPartial"] = $bff6195e160eb6bb$export$e6966bd80a36700a;

});

parcelRegister("cLzNH", function(module, exports) {
const $7caf3fc74a0e849a$export$86a2488e87c72bef = `
... on ExternalCase {
	displayNumber
	status
	isClosed
	lastUpdated
	owners {
		thirdPartyUser {
			accountId
			externalId
			name
			email
			id
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalCustomerOrg {
			id
			displayName
		}
	}
}
`;
module.exports["ExternalCasePartial"] = $7caf3fc74a0e849a$export$86a2488e87c72bef;

});

parcelRegister("hz68i", function(module, exports) {
const $69ceab5addb28b45$export$f68956972379b38e = `
... on SearchResultGraphCode {
    path
    repository {
        name
    }
}
`;
module.exports["ExternalCodePartial"] = $69ceab5addb28b45$export$f68956972379b38e;

});

parcelRegister("kAvaS", function(module, exports) {
const $0120149ae6de1c61$export$fd6f695cd68738d3 = `
... on ExternalComment {
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalCommentPartial"] = $0120149ae6de1c61$export$fd6f695cd68738d3;

});

parcelRegister("9SGbr", function(module, exports) {
const $39d0f148140689b8$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $39d0f148140689b8$export$3dcd3e619ad10a8c;

});

parcelRegister("jj5HY", function(module, exports) {
const $f7fca3b302c4ee56$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $f7fca3b302c4ee56$export$4597d51c3a28368e;

});

parcelRegister("3pr5k", function(module, exports) {
const $f54ec1bcc8120248$export$7a4547f8268cefd4 = `
... on ExternalCustomerOrg {
	country
	accountType
	thirdPartyId
	websiteUrl
	industry
	displayName
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2"){
		...on ExternalCustomerOrg {
			id
			displayName
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
}
`;
module.exports["ExternalCustomerOrgPartial"] = $f54ec1bcc8120248$export$7a4547f8268cefd4;

});

parcelRegister("Qrt3A", function(module, exports) {
const $012310a029ac1895$export$7192c9d070d6e5d6 = `
... on ExternalDashboard {
	id
	url
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	elements {
		name
		innerComponents
	}
	pages {
		name
	}
}
`;
module.exports["ExternalDashboardPartial"] = $012310a029ac1895$export$7192c9d070d6e5d6;

});

parcelRegister("dehBN", function(module, exports) {
const $42b56a54e74c8c0b$export$9f456561562ee774 = `
... on ExternalDataTable {
	id
	url
	dataTableType: type
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	columns {
		name
		columnType
		description
		isRequired
	}
}
`;
module.exports["ExternalDataTablePartial"] = $42b56a54e74c8c0b$export$9f456561562ee774;

});

parcelRegister("9mUth", function(module, exports) {
const $f5fd0a4589b8034c$export$d80c383820958dae = `
... on ExternalDeal {
	stage
	accountName
	dealClosedAt
	isClosed
	thirdPartyId
	parentId
	lastActivity {
		lastActivityAt
		event
	}
	opportunityAmount {
		value
		currencyCode
	}
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
	contact {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalCustomerOrg {
          id
          displayName
        }
    }
}
`;
module.exports["ExternalDealPartial"] = $f5fd0a4589b8034c$export$d80c383820958dae;

});

parcelRegister("aJW2w", function(module, exports) {
const $39e53f175a761c4f$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $39e53f175a761c4f$export$5eda2cda79f28143;

});

parcelRegister("4tpwN", function(module, exports) {
const $5294e72074a3a62d$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    thirdPartyId
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
            displayName
            url
        }
    }
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
            displayName
            url
		}
	}
    reactions {
        reactionType
        total
    }
}
`;
module.exports["ExternalDocumentPartial"] = $5294e72074a3a62d$export$6193eef58692a804;

});

parcelRegister("iCTu1", function(module, exports) {
const $0641c5f18f3be5c0$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    lastActive
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                    nickname
                    email
                    extendedProfile {
                        jobTitle
                        department
                        organization
                    }
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        email
						externalId
                        name
                        nickname
                        picture
                        extendedProfile {
                            jobTitle
                            department
                            organization
                        }
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $0641c5f18f3be5c0$export$3b9ed83b2b731ba0;

});

parcelRegister("kRTZx", function(module, exports) {
const $a189d094eec8b8a7$export$f35cf9a497ba81f2 = `
... on ExternalProject {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	key
	status
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalProjectPartial"] = $a189d094eec8b8a7$export$f35cf9a497ba81f2;

});

parcelRegister("4Kdn3", function(module, exports) {
const $2ff98bb615bc49d0$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
	pullRequestStatus: status
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $2ff98bb615bc49d0$export$fa7eefb2a03609fe;

});

parcelRegister("kt77u", function(module, exports) {
const $2324352047e71f08$export$2d22922c940459cd = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;
module.exports["ExternalRemoteLinkPartial"] = $2324352047e71f08$export$2d22922c940459cd;

});

parcelRegister("7lYRh", function(module, exports) {
const $420e540ce0776fdb$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $420e540ce0776fdb$export$82972f33e243e789;

});

parcelRegister("kZuSh", function(module, exports) {
const $7bbf9fdc766a97ba$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    thumbnailUrl
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $7bbf9fdc766a97ba$export$d872aa2b0db5eb10;

});

parcelRegister("bwf3l", function(module, exports) {
const $b22e61a89b72835b$export$a50a1db4dd4e2aa3 = `
... on ExternalWorkItem {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	collaborators {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	exceedsMaxCollaborators
	workItemProject {
		id
		name
	}
	status
	subtype
	team
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalWorkItemPartial"] = $b22e61a89b72835b$export$a50a1db4dd4e2aa3;

});

parcelRegister("aXWlG", function(module, exports) {
const $e09ee1476032fa0c$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $e09ee1476032fa0c$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
const $e09ee1476032fa0c$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $e09ee1476032fa0c$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $e09ee1476032fa0c$export$6ed59678949b7701 = (partial)=>{
    return $e09ee1476032fa0c$export$d40aaa445b6f7858(partial) || $e09ee1476032fa0c$export$980cabf11d827509(partial);
};
const $e09ee1476032fa0c$export$73993ded7a48a460 = ()=>{
    return `
		${$e09ee1476032fa0c$var$SearchResultTrelloBoard}
		${$e09ee1476032fa0c$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $e09ee1476032fa0c$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $e09ee1476032fa0c$export$73993ded7a48a460;

});

parcelRegister("khsIl", function(module, exports) {

var $3VnuG = parcelRequire("3VnuG");

const $6e75b22e6c02e0d9$export$e88fb694deeca21a = 'smartlinks-connector';
const $6e75b22e6c02e0d9$export$83921c8e433ffcd9 = 'lite-connector-';
const $6e75b22e6c02e0d9$export$7ad7a95070d8bb93 = (0, $3VnuG.ConnectorSources).Federated;
const $6e75b22e6c02e0d9$export$e3a0662f044cd99b = (0, $3VnuG.ConnectorSources).Lite;
const $6e75b22e6c02e0d9$export$c14e5e3fa6d8b46 = (0, $3VnuG.ConnectorSources).Smartlinks;
const $6e75b22e6c02e0d9$export$aa06c0b5cc41ad9a = (0, $3VnuG.ConnectorSources).Full;
const $6e75b22e6c02e0d9$export$37e0ed5b7fa94503 = (0, $3VnuG.ConnectorSources).Backfill;
const $6e75b22e6c02e0d9$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $3VnuG.ConnectorSources)).includes(value);
};
const $6e75b22e6c02e0d9$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $6e75b22e6c02e0d9$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($6e75b22e6c02e0d9$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry = new Map();
const $6e75b22e6c02e0d9$export$4e96e986802512bd = (productKey, icon)=>{
    $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $6e75b22e6c02e0d9$export$2f2bd8960b497856 = (productKey)=>{
    return $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.get(productKey);
};
const $6e75b22e6c02e0d9$export$2768da79a2599ca3 = ()=>{
    $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.clear();
};
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$aa06c0b5cc41ad9a;
module.exports["isForgeConnectorProductKey"] = $6e75b22e6c02e0d9$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $6e75b22e6c02e0d9$export$4e96e986802512bd;

});

parcelRegister("3VnuG", function(module, exports) {
const $183da3e19a5e988e$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $183da3e19a5e988e$export$499e9a6668a55181;

});

parcelRegister("7JSTC", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $khsIl = parcelRequire("khsIl");


var $fj6km = parcelRequire("fj6km");


var $dz5JF = parcelRequire("dz5JF");

const $eb4f8128cc69edb8$export$70bfed163de04616 = (forgeConnector, onForgeConnectorTypeMapping)=>{
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $fj6km.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $fj6km.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    (0, $khsIl.registerForgeConnectorIcon)(productKey, icon);
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $dz5JF.mapAtisToTypeFilterConfig)(forgeConnector.entityTypes) : new Map();
    if (onForgeConnectorTypeMapping && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) onForgeConnectorTypeMapping(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.environmentType ? `${forgeConnector.workspaceName} (${forgeConnector.environmentType})` : forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        // `forgeConnector.integrationId` is a `string` (the wire shape).
        // `PlatformIntegrationAri` is a branded nominal type. The value at
        // this site is already an integration ARI (built server-side by the
        // platform integration registry), so the cast is structurally safe;
        // the `unknown` hop exists only because TS rejects direct
        // `string`-to-branded assignment. Same pattern is used in
        // `adapter.ts`. RAOC-22 follow-up: tighten in search-client by
        // exposing a constructor for branded ARIs.
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $khsIl.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
module.exports["mapForgeConnectorToThirdPartyConfig"] = $eb4f8128cc69edb8$export$70bfed163de04616;

});


//# sourceMappingURL=object-preview-panel.e8d218cb.js.map
